import { Select } from '@material-ui/core'
import styled from '../../../theme'

export default styled(Select)`
  font-family: 'Montserrat', sans-serif !important;
`
